import { SxProps, Theme } from '@mui/material';

type TStyles = {
  root: SxProps<Theme>;
  main: SxProps<Theme>;
  title: SxProps<Theme>;
  contentContainer: SxProps<Theme>;
  actions: SxProps<Theme>;
  tableSearchField: SxProps<Theme>;
  tableNavigationButtons: SxProps<Theme>;
  tableNavigationText: SxProps<Theme>;
  tableTooltipText: SxProps<Theme>;
};

export const styles: TStyles = {
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    bgcolor: '#F5F5F5',
  },
  main: {
    minHeight: 'calc(100vh - 180px)',
    px: { xs: 2, md: 8.75 },
    py: 3.75,
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    mt: 0,
    mb: 3,
  },
  contentContainer: {
    m: 0,
    p: { xs: 2.5, md: '35px 40px' },
    display: 'flex',
    flexDirection: 'column',
    bgcolor: '#fff',
    borderRadius: '15px',
  },
  actions: {
    pb: 2.5,
    flexWrap: 'wrap',
    rowGap: 1,
  },
  tableSearchField: {
    width: { xs: '100%', md: '50%' },
    position: 'relative',
    pb: '17px',
  },
  tableNavigationButtons: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
    gap: '15px',
    mt: '25px',
  },
  tableNavigationText: {
    fontSize: '16px',
  },
  tableTooltipText: {
    cursor: 'pointer',
  },
};
